import React, { useState } from "react";
import { Button, Pagination, Table } from "antd";
import moment from "moment";

import { ContentLoader } from "@components";
import { i18, trb } from "@utilities";
import useAppConfigControl from "@hooks/useAppConfigControl";
import { CONFIGS } from "@config/Applications";
import { NaceBlockersTableFilter } from "../Util/NaceBlockersTableFilter";

import "./RisksSettingsTab.less";
import { EditNaceBlocker } from "../Modals/EditNaceBlocker";

const INITIAL_FILTERS_VALUES = {
  title: "",
  code: "",
  isActual: undefined,
  page: 1,
  rowsPerPage: 20,
  withHistory: undefined
};

export const NaceBlockersSettingsTab = React.memo(() => {
  const {
    onFilter,
    onPageChange,
    tableFilters: naceBlockersFilters,
    config: naceBlockersConfig,
    isLoading,
    downloadExcel,
    isDownloadingExcel
  } = useAppConfigControl({
    initialFilters: INITIAL_FILTERS_VALUES,
    configKey: CONFIGS.NACE_BLOCKERS
  });

  const [hoveredBlocker, setHoveredBlocker] = useState();
  const [selectedBlocker, setSelectedBlocker] = useState();

  if (isLoading) {
    return <ContentLoader />;
  }

  const blockersColumn = [
    {
      title: trb(i18.ApplicationsLabels.NaceBlockersTitleCol),
      dataIndex: "title",
      key: "title"
    },
    {
      title: trb(i18.ApplicationsLabels.NaceBlockersCodeCol),
      dataIndex: "code",
      key: "code"
    },
    {
      title: trb(i18.ApplicationsLabels.NaceBlockersIsActualCol),
      dataIndex: "isActual",
      key: "isActual",
      render: item =>
        item
          ? trb(i18.ApplicationsLabels.NaceBlockersIsActualTrue)
          : trb(i18.ApplicationsLabels.NaceBlockersIsActualFalse)
    },
    {
      title: trb(i18.ApplicationsLabels.NaceBlockersCreatedCol),
      dataIndex: "created",
      key: "created",
      render: item => item && moment(item).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: trb(i18.ApplicationsLabels.NaceBlockersDeletedDateCol),
      dataIndex: "deletedDate",
      key: "deletedDate",
      render: item => item && moment(item).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      key: "action",
      render: row => {
        if (row.id !== hoveredBlocker) return <div className="btn-placeholder" />;
        return (
          <Button onClick={() => setSelectedBlocker(row)} type="primary">
            {trb(i18.Buttons.Edit)}
          </Button>
        );
      }
    }
  ];

  return (
    <>
      <div className="risks-settings-tab">
        <NaceBlockersTableFilter
          onFilter={onFilter}
          filterValues={naceBlockersFilters}
          handleDownload={downloadExcel}
          isDownloadingExcel={isDownloadingExcel}
        />
        <Table
          className="w-100 mb-3"
          dataSource={naceBlockersConfig.items}
          columns={blockersColumn}
          scroll={{ x: "60vw" }}
          pagination={false}
          rowKey="id"
          size="middle"
          onRow={record => {
            return {
              onMouseEnter: () => setHoveredBlocker(record.id),
              onMouseLeave: () => setHoveredBlocker(undefined)
            };
          }}
        />
        <div className="text-right">
          <Pagination
            showSizeChanger
            pageSize={naceBlockersFilters.rowsPerPage}
            current={naceBlockersFilters.page}
            onChange={onPageChange}
            defaultCurrent={1}
            total={naceBlockersConfig.paging.totalItems}
          />
        </div>
      </div>
      {selectedBlocker && (
        <EditNaceBlocker
          onClose={() => setSelectedBlocker(undefined)}
          blockerConfig={selectedBlocker}
        />
      )}
    </>
  );
});
